import { createContext } from 'react';
import { PoolCarSettingsContextProps } from './pool-car-booking-settings.types';

export const PoolCarSettingsContext = createContext<PoolCarSettingsContextProps>({} as PoolCarSettingsContextProps);
